import { cva } from 'class-variance-authority';
/**
 * Switch는 초이스 키를 쓰되 사각이 아니다.
 * 트랙·엄지 비율은 기존(h≈1.15rem / w-8 / thumb size-4)을 밀도만 스케일한다.
 */
const switchSizeMap = {
    default: 'h-[1.15rem] w-8',
    md: 'h-[1.15rem] w-8',
    sm: 'h-[length:var(--choice-size-sm)] w-7',
    lg: 'h-[length:var(--choice-size-lg)] w-10',
};
const switchThumbSizeMap = {
    default: 'size-[length:var(--choice-size)]',
    md: 'size-[length:var(--choice-size-md)]',
    sm: 'size-[length:calc(var(--choice-size-sm)-0.125rem)]',
    lg: 'size-[length:var(--choice-size-lg)]',
};
export const switchCva = {
    variants: {
        size: switchSizeMap,
    },
    defaultVariants: {
        size: 'default',
    },
};
export const switchVariants = cva('peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50', switchCva);
export const switchSizeKeys = Object.keys(switchCva.variants.size);
export function switchThumbClass(size) {
    const key = size && size in switchThumbSizeMap ? size : 'default';
    return cnThumb(key);
}
function cnThumb(key) {
    return [
        'bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
        switchThumbSizeMap[key],
    ].join(' ');
}
//# sourceMappingURL=switch.cva.js.map